import { FastSearchComponent } from './../../blocks/ui-component/fast-search/fast-search.component';

import { Location } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

//shared libs
import { AppCodeGroup, ControlsParams, UserSessionService } from '../../shared';
import { EntityService, ModalService, ToastService, ControlsComponent } from '../../blocks';
import { UsersGroupService } from './usersGroup.service';
import { UsersGroup } from './usersGroup';

import { User } from '../userData/user.service';
@Component({
    selector: 'sanabel-usersGroup',
    templateUrl: './usersGroup.component.html'
})
//++++++++++++++++++++++++++++++++++#gouhar+++++++++++++++++++++++++++++++++
//++++++++++++++++++++++++++++++++++#gouhar+++++++++++++++++++++++++++++++++

export class UsersGroupComponent implements OnInit {
    //++++++++++++++++++++++++++++++++++#gouhar+++++++++++++++++++++++++++++++++
    @ViewChild('fastSearch') fastSearch: FastSearchComponent;

    @Input() usersGroup: UsersGroup;
    @Input() userGroupCode: number;
    @Input() defaultGroupCode: number;
    editUser: User = <User>{};
    editUsersGroup: UsersGroup = <UsersGroup>{};
    controlsParams: ControlsParams;
    userGroup: UsersGroup[] = [];
    groupsArray: any[] = [];
    filterArray: any[] = [];
    groups: any[];
    allChecked: boolean = false;
    count: number = 0;
    values: any[] = [];

    //++++++++++++++++++++++++++++++++++#gouhar+++++++++++++++++++++++++++++++++

    constructor(
        private _usersGroupService: UsersGroupService,
        private _entityService: EntityService,
        private _modalService: ModalService,
        private _router: Router,
        public translate: TranslateService,
        private _route: ActivatedRoute,
        private _userSessionService: UserSessionService,
        private _location: Location,
        private _toastService: ToastService) {

        this.controlsParams = new ControlsParams(555, AppCodeGroup.Buttons, true);

    }

    //++++++++++++++++++++++++++++++++++#gouhar+++++++++++++++++++++++++++++++++

    ngOnInit() {
        this._userSessionService.subscribeToKey$('ResetUser')
            .subscribe((keys: any) => {
                if (keys.value && keys.value == 1) {
                    this.getGroupsReset();
                }
            });
    }

    ////////////reset
    getGroupsReset() {
     this.groupsArray = [];
        this._usersGroupService.getGroups(0).subscribe(
            s => {
                this.groupsArray = s.data;
                this.values = Object.assign([], this.groupsArray);
            });

    }


    ////////////get users
    getGroups(user: any) {

        this.groupsArray = [];
        this._usersGroupService.getGroups(user.userID).subscribe(
            s => {
                this.groupsArray = s.data;
                this.values = Object.assign([], this.groupsArray);
                if (this.groupsArray.length > 0)
                    this.editUser = <User>this._userSessionService.getSessionKey('userParms');
                if (this.editUser)
                    this.groupsArray = this.excoudeDefaultGroup(this.groupsArray, this.editUser["defaultGroup"]);
            });
            this.filterArray=this.groupsArray

    }
    // select a service
    selectedgroups(group: any) {
        group.selected = !group.selected;
    }
    toggleAll() {

        this.allChecked = !this.allChecked;
        for (var i = 0; i < this.groupsArray.length; i++) {
            this.groupsArray[i].selected = this.allChecked;
        }
    }



    excoudeDefaultGroup(groupsArray: Array<any>, defaultGroup: number): Array<any> {

        return groupsArray.filter(groups => groups.groupID1 != defaultGroup);
    }
    save() {
        this.userGroup = [];
        this.editUser = <User>this._userSessionService.getSessionKey('userParms');
        this.userGroupCode = this.editUser.userID;
        if (this.userGroupCode == undefined || this.userGroupCode == null) {
            this._toastService.activateMsg('UI40');
            return;
        }
        //  عشان اللى بيهمنى ال sec login مش محتاج اضيفها ف الربطهه
        ///to add deafult group

        //if (this.userGroupCode != undefined || this.userGroupCode != null) {
        //    var temp: UsersGroup = {
        //        id: 0,
        //        userId: this.userGroupCode,
        //        groupID: this.defaultGroupCode,
        //        selected: true
        //    };

        //    this.userGroup.push(temp)
        //}
        if (this.groupsArray.length > 0)
            for (var i = 0; i < this.groupsArray.length; i++) {
                if ((this.groupsArray[i].groupId > 0 && !this.groupsArray[i].selected) || (this.groupsArray[i].selected && this.groupsArray[i].groupId == null)) {
                    var prem: UsersGroup = {
                        id: (this.groupsArray[i].code ? this.groupsArray[i].code : (i + 1) * -1),
                        userId: this.userGroupCode,
                        groupID: this.groupsArray[i].groupID1,
                        selected: this.groupsArray[i].selected
                    };
                    this.userGroup.push(prem);
                }
            }
        if (this.userGroup.length > 0)
            this._usersGroupService.addGroupsToUser(this.userGroup)
                .subscribe(c => {
                    let uerTemp = this._userSessionService.getSessionKey('userParms');
                    this.getGroups(uerTemp);

                });
    }
    //++++++++++++++++++++++++++++++++++#gouhar+++++++++++++++++++++++++++++++++


    cancel(showToast = true) {
        this.editUsersGroup = this._entityService.clone(this.usersGroup);
        this._goBack();
    }
    //++++++++++++++++++++++++++++++++++#gouhar+++++++++++++++++++++++++++++++++


    _goBack(): void {
        this._location.back();
    }
    //#endregion
    
    onKeyUp(value: string) {
        if (value && value.length > 0) {
            this.groupsArray = [];
            this.groupsArray = this.values.filter(s => s['nameAr'].includes(value));
        }
        if( value.length ==  0){
            this.groupsArray = this.values;
        }
    }
}
    //++++++++++++++++++++++++++++++++++#gouhar+++++++++++++++++++++++++++++++++
    //++++++++++++++++++++++++++++++++++#gouhar+++++++++++++++++++++++++++++++++
    //++++++++++++++++++++++++++++++++++#gouhar+++++++++++++++++++++++++++++++++
